import { NgStyle } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
	selector: 'app-accordion-item',
	imports: [NgStyle],
	templateUrl: './accordion-item.component.html',
	styleUrl: './accordion-item.component.scss',
})
export class AccordionItemComponent {
	@Input() itemId: string;
	@Input() parentId: string;
	@Input() isOpen?: boolean = false;
	@Input() disableExpand?: boolean = false;
	@Input() lineHeight?: number = 30;

	@Output() toggleEvent = new EventEmitter<boolean>();

	buttonPaddingY = this.lineHeight! / 2 - 10;

	onShow(): void {
		this.isOpen = true;
		this.toggleEvent.emit(true);
	}

	onClose(): void {
		this.isOpen = false;
		this.toggleEvent.emit(false);
	}

	toggleAccordion() {
		if (this.disableExpand) {
			this.toggleEvent.emit(true);
			return;
		}
		this.isOpen = !this.isOpen;
		this.toggleEvent.emit(this.isOpen);
	}
}
